// extracted by mini-css-extract-plugin
export default {"dialog_body":"styles_dialog_body__9A5zT"};